import type { IconSvgObject } from './types';

const BlindsIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "16", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 6H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 10H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 10V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M2.99997 20V4C2.99997 2.89543 3.8954 2 4.99997 2H19C20.1045 2 21 2.89543 21 4V20C21 21.1046 20.1045 22 19 22H4.99997C3.8954 22 2.99997 21.1046 2.99997 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default BlindsIcon;
